import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import OpenInNewIcon from '../../images/svg/open_in_new.svg';
import BVLogo from '../../images/svg/logo-bv.svg';
import BoatHistoryLogo from '../../images/boathistory-logosmall.png';
import ProgressiveLogo from '../../images/svg/progressive-logo.svg';

const JDPACustomButtonMenu2 = () => (
    <div className="jdpa-custom-menu-mobile">
        <MenuItem component="a" className="expandable-list-item" href="https://www.jdpower.com/cars">Autos</MenuItem>
        <MenuItem component="a" className="expandable-list-item" href="https://www.jdpower.com/motorcycles">Motorcycles</MenuItem>
        <MenuItem component="a" className="expandable-list-item" href="https://www.jdpower.com/rvs">RVs</MenuItem>
        <MenuItem component="a" className="expandable-list-item" href="https://www.jdpower.com/boats">Boats</MenuItem>
        <MenuItem component="a" className="expandable-list-item" href="https://www.jdpower.com/manufactured-homes/">Manufactured Homes</MenuItem>
        <MenuItem component="a" className="expandable-list-item" href="https://www.jdpowervalues.com/">B2B Valuation Products</MenuItem>
        <Divider className="menu-divider" />
        <MenuItem>
            <span className="sub-header">Auto Resources</span>
        </MenuItem>
        <MenuItem component="a" className="expandable-list-item" href="https://www.beenverified.com/?utm_source=6388&utm_medium=affiliate&utm_campaign=1119&subid=&segfid=6388_1119&aff_sub=nav&aff_sub2=&aff_sub3=&ho_id=102f28c42cc1066830fc9315fb6378">
            Vehicle History Report
            <img src={OpenInNewIcon} style={{ height: '1em', width: '1em' }}/>
            <img src={BVLogo} style={{ height: '15px', width: '98px' }}/>
        </MenuItem>
        <Divider className="menu-divider" />
        <MenuItem>
            <span className="sub-header">Specialty Resources</span>
            <img src={OpenInNewIcon} style={{ height: '1em', width: '1em' }}/>
        </MenuItem>
        <MenuItem component="a" className="expandable-list-item" href="https://boathistoryreport.com/?utm_source=jdp&utm_medium=Resources&hin=&boat=&price=&utm_campaign=affiliate&cbnadag=20211131453196874">
            Boat History Report
            <img src={OpenInNewIcon} style={{ height: '1em', width: '1em' }}/>
            <img src={BoatHistoryLogo} style={{ height: '15px', width: '83px' }}/>
        </MenuItem>
        <MenuItem>
            <span className="sub-header">Specialty Insurance</span>
            <img src={ProgressiveLogo} style={{ height: '18px', width: '100px' }}/>
        </MenuItem>
        <MenuItem component="a" className="expandable-list-item" href="https://www.progressive.com/lp/motorcycle/?code=9106010020&cbnadag=20211131454593880undefined">
            Motorcycle Insurance
            <img src={OpenInNewIcon} style={{ height: '1em', width: '1em' }}/>
        </MenuItem>
        <MenuItem component="a" className="expandable-list-item" href="https://www.progressive.com/lp/rv/?code=9106000051&cbnadag=20227281755286978undefined">
            RV Insurance
            <img src={OpenInNewIcon} style={{ height: '1em', width: '1em' }}/>
        </MenuItem>
        <MenuItem component="a" className="expandable-list-item" href="https://www.progressive.com/lp/boat/?code=9106000029&cbnadag=20211131455474290undefined">
            Boat Insurance
            <img src={OpenInNewIcon} style={{ height: '1em', width: '1em' }}/>
        </MenuItem>
    </div>
);

export default JDPACustomButtonMenu2;